import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { DecimalPlacesStandalonePipe } from 'v2/modules/shared/pipes/decimal-places.pipe';

@Component({
  selector: 'lum-cost-layer-quantity-progress',
  templateUrl: './cost-layer-quantity-progress.component.html',
  styleUrls: ['./cost-layer-quantity-progress.component.scss'],
  standalone: true,
  imports: [CommonModule, DecimalPlacesStandalonePipe],
})
export class CostLayerQuantityProgressComponent implements OnChanges {
  @Input() initialQuantity :number = 0;
  @Input() remainingQuantity :number = 0;

  displayValue :number = 0;
  progressPercentage :number = 0;

  ngOnChanges(changes :SimpleChanges) :void {
    if (changes.initialQuantity || changes.remainingQuantity) {
      this.#calculateValues();
    }
  }

  #calculateValues() :void {
    this.progressPercentage =
      this.initialQuantity === 0 // avoid division by zero
        ? 0
        : (this.remainingQuantity / this.initialQuantity) * 100;

    this.displayValue =
      this.remainingQuantity > 0
        ? Math.max(
            this.remainingQuantity,
            this.initialQuantity * 0.02, // we always wanna show a little bit if there are any left
          )
        : this.remainingQuantity;
  }
}
